import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppService } from '../services/api-services/app.service';
import { KRollService } from '../services/api-services/kroll.service';

@Injectable({
  providedIn: "root"
})
export class AppResolver implements Resolve<any> {
  constructor(
    public krollService: KRollService,
    public appService: AppService,
    public router: Router) {

  }
  resolve(route: ActivatedRouteSnapshot) {
    return this.appService.getAppData().pipe(map(res => {
      let response: any = res;
      if (response['serverLocations']['success']) {
        response['serverLocations'] = response['serverLocations']['data'];
      }
      if (response['deliveryPartner']['success']) {
        response['deliveryPartner'] = response['deliveryPartner']['data'];
      }
      return response;
    }));
  }
}
